import { api } from '../../../shared/services/api/client';

export const getAllRewards = () => {
    return api.get('/merchant/rewards');
};

export const createReward = (form) => {
    return api.post('/merchant/rewards', form);
};

export const deleteReward = (id) => {
    return api.delete(`/merchant/rewards/${id}`);
};

export const getGlobalRewardsSettings = () => {
    return api.get('/merchant/rewards/settings');
};

export const getRewardAnalytics = () => {
    return api.get('/merchant/rewards/analytics');
};

export const rewardsAPI = {
    getAllRewards,
    createReward,
    deleteReward,
    getGlobalRewardsSettings,
    getRewardAnalytics,
};
